module.exports = __webpack_public_path__ + "static/media/Сентябрьская день.834ee97c.jpg";